import EventEmitter from 'events'

class Hook {
  constructor() {
    this.emitter = new EventEmitter()
    this.types = Hook.types
  }
  addHook = (name, cb) => {
    if (Hook.types[name] === undefined) {
      // throw new Error('钩子类型不存在')
    }
    this.emitter.on(name, cb)
  }
  addOnceHook = (name, cb) => {
    if (!Hook.types.hasOwnProperty(name)) {
      throw new Error('钩子类型不存在')
    }
    this.emitter.once(name, cb)
  }
  fireHook = (name, params) => {
    this.emitter.emit(name, params)
  }
}

Hook.types = {
  BEFORE_SAVE: 0,
  AFTER_SAVE: 1,
  BEFORE_SUBMIT: 2,
  AFTER_SUBMIT: 3,
  BEFORE_CHECK: 4,
  AFTER_CHECK: 5,
  AFTER_CHECK_BACKGROUND: 6
}

export default new Hook()